<template>
  <div class="row job-config left-nav-collapsible" v-show="!loading && jobTemplate.created_at">
    <div v-if="detailPageOpen" id="detail-page-open">
      <button
        class="btn details-open-btn"
        type="button"
        @click="onDetailPageOpenClose(false)"
      >
        <span> <i class="fa fa-caret-right"></i></span>
      </button>
    </div>
    <TransitionGroup :name="jobTemplate.created_at ? 'slide' : ''" key="detail">
      <div v-if="showCloseBtn && !detailPageOpen" id="detail-page-close" key="close">
        <button
          class="btn text-start details-open-btn"
          type="button"
          @click="onDetailPageOpenClose(true)"
        >
          <span> <i class="fa fa-caret-left"></i></span>
        </button>
      </div>
      <div
        v-if="!detailPageOpen"
        id="details-col"
        @mouseover="onDetailPageHover(true)"
        key="details-col"
      >
        <div class="card">
          <div class="card-header">
            <h5 class="card-header-title">
              System Files<span
                class="fa fa-circle-info text-muted"
                title="use [[UPPERCASE_WITH_UNDERSCORES]] for dynamic template field, eg: [[OUTPUT_PATH]]"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
              ></span>
            </h5>
            <button
              type="button"
              data-bs-toggle="collapse"
              href="#collapse-files-div"
              aria-expanded="true"
              aria-controls="collapse-files-div"
              id="collapse-btn"
              class="btn btn-sm"
            >
              <i class="fa fa-chevron-up float-end"></i>
            </button>
          </div>
          <div
            id="collapse-files-div"
            class="collapse show"
            aria-labelledby="collapse-btn-1"
          >
            <div class="card-body py-3">
              <p v-if="!jobTemplate.system_files || jobTemplate.system_files.length == 0">
                No configuration system files found.
              </p>
              <list-group
                :title="'File List'"
                :editMode="editMode"
                :list="jobTemplate.system_files"
                :activeListItem="activeTab"
                listItemKey="relative_path"
              ></list-group>
              <div v-if="editMode" class="mb-4">
                <button
                  v-if="!addingSystemFile"
                  @click="showAddFile('System')"
                  class="btn btn-sm btn-primary float-end"
                  type="button"
                >
                  Add File
                </button>
                <div v-else>
                  <form @submit.prevent="addFile('system')">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="example.yaml"
                        v-model="newsystemFileName"
                        autofocus
                      />
                      <button
                        @click="addFile('system')"
                        class="btn btn-outline-secondary"
                        type="submit"
                      >
                        OK
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="card-header">
            <h5 class="card-header-title">
              User Files
              <span
                class="fa fa-circle-info text-muted"
                title="use [[UPPERCASE_WITH_UNDERSCORES]] for dynamic template field, eg: [[OUTPUT_PATH]]"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
              ></span>
            </h5>
            <button
              type="button"
              data-bs-toggle="collapse"
              href="#collapse-files-div"
              aria-expanded="true"
              aria-controls="collapse-files-div"
              id="collapse-btn"
              class="btn btn-sm"
            >
              <i class="fa fa-chevron-up float-end"></i>
            </button>
          </div>
          <div
            id="collapse-files-div"
            class="collapse show"
            aria-labelledby="collapse-btn-1"
          >
            <div class="card-body py-3">
              <p v-if="!jobTemplate.user_files || jobTemplate.user_files.length == 0">
                No configuration user files found.
              </p>
              <list-group
                :editMode="editMode"
                :title="'File List'"
                :list="jobTemplate.user_files"
                :activeListItem="activeTab"
                listItemKey="relative_path"
                @deleteBtnClick="(e) => onFileDelete(e, 'user')"
                @selectBtnclick="showFile"
              ></list-group>
              <div v-if="editMode" class="mb-4">
                <button
                  v-if="!addingUserFile"
                  @click="showAddFile('User')"
                  class="btn btn-sm btn-primary float-end"
                  type="button"
                >
                  Add File
                </button>
                <div v-else>
                  <form @submit.prevent="addFile('user')">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="example.yaml"
                        v-model="newuserFileName"
                        autofocus
                      />
                      <button
                        @click="addFile('user')"
                        class="btn btn-outline-secondary"
                        type="submit"
                      >
                        OK
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="card-header">
              <h5 class="card-header-title">Options</h5>
              <button
                type="button"
                data-bs-toggle="collapse"
                href="#collapse-env-params-div"
                aria-expanded="true"
                aria-controls="collapse-env-params-div"
                id="collapse-btn-1"
                class="btn btn-sm"
              >
                <i class="fa fa-chevron-up float-end"></i>
              </button>
            </div>
            <div
              id="collapse-env-params-div"
              class="collapse show"
              aria-labelledby="collapse-btn-1"
            >
              <div class="card-body pt-2">
                <div class="">
                  <div class="form-group">
                    <label><h5>Kind</h5></label>
                    <InputField
                      :editable="editMode"
                      :showLabel="false"
                      type="text"
                      v-model="jobTemplate.kind"
                    />
                  </div>
                  <div class="form-group">
                    <label><h5>Schedule</h5></label>
                    <InputField
                      :editable="editMode"
                      :showLabel="false"
                      type="cron"
                      v-model="jobTemplate.schedule"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="card-header">
              <h5 class="card-header-title">Details</h5>
              <button
                type="button"
                data-bs-toggle="collapse"
                href="#collapse-props-div"
                aria-expanded="false"
                aria-controls="collapse-props-div"
                id="collapse-btn-2"
                class="btn btn-sm collapsed"
              >
                <i class="fa fa-chevron-up float-end"></i>
              </button>
            </div>
            <div
              id="collapse-props-div"
              class="collapse show"
              aria-labelledby="collapse-btn-2"
            >
              <div class="card-body pt-0">
                <div class="list-group list-group-flush">
                  <div class="list-group-item">
                    <div class="row align-items-center">
                      <div class="col">
                        <h5 class="mb-0">Author</h5>
                      </div>
                      <div class="col-auto">
                        <small class="text-muted">{{ jobTemplate.created_by }}</small>
                      </div>
                    </div>
                  </div>
                  <div class="list-group-item">
                    <div class="row align-items-center">
                      <div class="col">
                        <h5 class="mb-0">Commit (trunc)</h5>
                      </div>
                      <div class="col-auto">
                        <small class="text-muted">{{ gitCommit }}</small>
                      </div>
                    </div>
                  </div>
                  <div class="list-group-item">
                    <div class="row align-items-center">
                      <div class="col">
                        <h5 class="mb-0">Created</h5>
                      </div>
                      <div class="col-auto">
                        <small class="text-muted">{{
                          DateTimeFormat(jobTemplate.created_at)
                        }}</small>
                        <span class="badge badge-secondary">{{
                          convertToRelativeTime(jobTemplate.created_at)
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="list-group-item">
                    <div class="row align-items-center">
                      <div class="col">
                        <h5 class="mb-0">Updated</h5>
                      </div>
                      <div class="col-auto">
                        <small class="text-muted">{{
                          DateTimeFormat(jobTemplate.updated_at)
                        }}</small
                        ><span class="badge badge-secondary">{{
                          convertToRelativeTime(jobTemplate.updated_at)
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col" id="main-col" @mouseover="onDetailPageHover(false)" key="main-col">
      <tabs :tabs="tabItems" :btnTabs="true">
         <template v-slot:config>
          <div class="card">
            <div class="card-body" id="execution-config-div">             
              <job-editor
              :editMode="editMode"
              :jobType="jobTemplate.type"
              :activeTab="activeTab"
              v-on:tabChange="showTab"
              v-on:onLintFailure="onLintFailure"
              v-model="yamlContent"
            ></job-editor>
          </div>
          </div>
         </template>
         <template v-slot:meters>
            <JobTemplateMeters :meters="jobTemplate?.meters ||[]"/>
         </template>
         <template v-slot:parameters>
            <JobTemplateParameters :parameters="jobTemplate?.parameters ||[]" />
         </template>
      </tabs>
    </div>
    </TransitionGroup>
  </div>
  <div v-if="error" class="alert alert-danger" role="alert">
    {{ error }}
  </div>
  <div v-show="!error && (loading || !jobTemplate.created_at)" class="text-center">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import dayjs from "dayjs";
import { DateTimeFormat, relativeTime } from "../../utils/commonFunction";
import ListGroup from "../../components/ListGroup.vue";
import Tabs from "../../components/Tabs.vue";
import JobEditor from "../../components/sandbox/JobEditor.vue";
import InputField from "../../components/InputField.vue";
import JobTemplateMeters from "./JobTemplateMeters.vue";
import JobTemplateParameters from "./JobTemplateParameters.vue";

export default {
  name: "JobTemplate",
  components: { ListGroup, Tabs, JobEditor, InputField, JobTemplateMeters, JobTemplateParameters },
  data() {
    return {
      tag: null,
      jobTemplate: {},
      activeTab: "",
      yamlContent: {},
      error: "",
      loading: false,
      detailPageOpen: false,
      showCloseBtn: false,
      editMode :false,
      tabItems: [
                {
                    name: "Config",
                    id: "id1",
                    slot: "config"
                },
                {
                    name: "Meters",
                    id: "id2",
                    slot: "meters"
                },
                {
                    name: "Parameters",
                    id: "id3",
                    slot: "parameters"
                }

            ],
      gitCommit:null,
    };
  },
  props: ["editModeStack", "saveJobStack", "cancelClickStack", "meters", "parameters"],
  beforeMount() {
    this.fetchJobTemplate();
  },
  methods: {
    ...mapActions({
      readTemplateJob: "amdp/readTemplateJob"
    }),
    DateTimeFormat,
    initateYamlContent() {
      let yamlContent = {};

      if (this.jobTemplate.system_files) {
        for (const i of this.jobTemplate.system_files) {
          yamlContent[i.relative_path] = i.content;
        }
      }
      if (this.jobTemplate.user_files) {
        for (const i of this.jobTemplate.user_files) {
          yamlContent[i.relative_path] = i.content;
        }
      }
      //Initially activeTab value is empty or undefined otherwise no need to reset to first value
      if (!this.activeTab || this.activeTab == "")
        this.activeTab = Object.keys(yamlContent)[0];
      this.yamlContent = JSON.parse(JSON.stringify(yamlContent));
    },
    async fetchJobTemplate() {
      let response = {};
      try {
          response = await this.readTemplateJob(this.$route.params.name);
        } catch (error) {
          if (error.response.data.error) this.error = error.response.data.error;
          else this.error = error.message;
          return;
        }
      this.jobTemplate = await response.data;
      this.gitCommit = this.jobTemplate.git_commit ? this.jobTemplate.git_commit.slice(0, 8) : null;
      this.$emit("setJobTemplate", this.jobTemplate);
      this.$emit("setShowTemplate", this.jobTemplate.name? true: false);
      this.initateYamlContent();
    },
    showTab(tab) {
      this.activeTab = tab;
    },
    showFile(file) {
      this.activeTab = file.relative_path;
    },
    onLintFailure(isError) {
      this.$emit("onLintFailure", isError);
    },
    convertToRelativeTime(timestamp) {
      return relativeTime(Date.now(), dayjs(timestamp));
    },
    onDetailPageOpenClose(value) {
      this.showCloseBtn = false;
      this.detailPageOpen = value;
    },
    onDetailPageHover(value) {
      this.showCloseBtn = value;
    },
  },
  emits: [
    "onLintFailure",
    "setJobTemplate",
    "setShowTemplate",
    "hideEditBtnStack",
    "triggerEditModeStack",
    "setJobStack",
    "setShowJobStack"
  ],
};
</script>
<style scoped>
.job-config .card-header {
  background-color: #f9fbfd;
  text-transform: uppercase;
  color: #95aac9;
  height: 40px;
}
.job-config .collapsed .fa {
  transform: rotate(180deg);
}

</style>
